import $ from 'jquery';

export function accordion(event, parent, hide){
   
    $(hide).hide();

    $(event).on('click', function(){
        $(this).toggleClass('open');
        $(this).parent(parent).toggleClass('open');

        if($(this).parent(parent).hasClass('open')) {
            $(this).siblings(hide).slideDown();
        } else {
            $(this).siblings(hide).slideUp();
        }
    })
}


// WEBPACK FOOTER //
// app/scripts/components/accordion.js